import { fetchWithAuthHeader } from '../../auth';
import { jsonResponseHandling } from '../fetch';
import { getViewPermission } from '../helpers';
import { apiUrl, BUS_PROXIMITY_ENGINE_PATH } from '../api-manager';

export const getBusPriorityViewPermission = () => getViewPermission(apiUrl(`${BUS_PROXIMITY_ENGINE_PATH}/view`));

export const getBusPriorityRoutes = () => {
    const url = apiUrl(`${BUS_PROXIMITY_ENGINE_PATH}/priorityroute`);
    return fetchWithAuthHeader(
        url,
        {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
        },
    ).then(response => jsonResponseHandling(response));
};

export const deleteBusPriorityRoutes = (routeIds) => {
    const url = apiUrl(`${BUS_PROXIMITY_ENGINE_PATH}/priorityroute`);
    return fetchWithAuthHeader(
        url,
        {
            method: 'DELETE',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ routeIds }),
        },
    );
};

export const addBusPriorityRoute = (routeId) => {
    const url = apiUrl(`${BUS_PROXIMITY_ENGINE_PATH}/priorityroute`);
    return fetchWithAuthHeader(
        url,
        {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ routeId }),
        },
    );
};

export const getBusPriorityIntersections = () => {
    const url = apiUrl(`${BUS_PROXIMITY_ENGINE_PATH}/intersection`);
    return fetchWithAuthHeader(
        url,
        {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
        },
    ).then(response => jsonResponseHandling(response));
};

export const updateIntersection = (body) => {
    const url = apiUrl(`${BUS_PROXIMITY_ENGINE_PATH}/intersection`);
    return fetchWithAuthHeader(
        url,
        {
            method: 'PATCH',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(body),
        },
    );
};

export const getBusPriorityThresholds = () => {
    const url = apiUrl(`${BUS_PROXIMITY_ENGINE_PATH}/threshold`);
    return fetchWithAuthHeader(
        url,
        {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
        },
    ).then(response => jsonResponseHandling(response));
};

export const saveBusPriorityThresholds = (thresholds) => {
    const url = apiUrl(`${BUS_PROXIMITY_ENGINE_PATH}/threshold`);
    return fetchWithAuthHeader(
        url,
        {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(thresholds),
        },
    );
};

export const updateBusPriorityThresholds = (previousThresholds, thresholds) => {
    const url = apiUrl(`${BUS_PROXIMITY_ENGINE_PATH}/threshold`);
    return fetchWithAuthHeader(
        url,
        {
            method: 'PUT',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                previousThresholds,
                updatedThresholds: thresholds,
            }),
        },
    );
};

export const deleteBusPriorityThresholds = (thresholds) => {
    const url = apiUrl(`${BUS_PROXIMITY_ENGINE_PATH}/threshold`);
    return fetchWithAuthHeader(
        url,
        {
            method: 'DELETE',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(thresholds),
        },
    );
};
